export enum StoredRouteActionTypes {
    SET_CURRENT_ROUTE = '@@storedRoute/SET_CURRENT_ROUTE',
    SET_MENU_COLLAPSE_STATE = '@@storedRoute/SET_MENU_COLLAPSE_STATE',
}

export interface StoredRouteState {
    readonly currentRoute: string;
    readonly menuCollapsed: boolean;
}
